import { Spinner } from '..';
export const Loader = () => {
    return (
        <div className="flex justify-center">
            <Spinner />
        </div>
    );
};
